module.exports = __webpack_public_path__ + "media/images/lp_point-e7420f0c4bb3d92820b4f3f93c865f5f.webp";